<template>
  <div>
    <div id="container">
      <section id="register">
        <div class="wrap">
          <form @submit="submitClicked">
            <div class="cts_box">
              <h2 class="sub_ttl"><span>ゲストユーザー登録</span></h2>
              <p class="lead red bold">
                こちらからゲストユーザーへの登録ができます。<br />
                ※ゲストユーザーの方は利用できるコンテンツに制限があります。
              </p>
              <div class="cts_box mt50">
                <h3 class="min_ttl">入塾金と⽉謝について</h3>
                <p class="bold mb10">
                  ゲストユーザーの方は、入塾金・月謝のお支払いは不要です。
                </p>
                <p class="join_date" v-if="false">
                  現在のお申込みで{{
                    moment(getMembershipJoinDate(new Date()), "YYYY年M月")
                  }}1日の入塾です。
                </p>
                <div class="course_box fee" v-if="false">
                  <h4>
                    <span>入塾金</span>
                    <div class="fee_price"><span>税込</span>¥10,000</div>
                  </h4>
                </div>
              </div>
              <div class="experience" v-if="false">
                <div class="main_img">
                  <img
                    src="/common/images/experience_mv.jpg"
                    alt="ワンコイン体験入塾へようこそ！"
                  />
                </div>
                <h3>ワンコイン体験入塾へようこそ！</h3>
                <p class="alnC sp_alnL">
                  以下、いくつかお手続きについて<span class="bold red"
                    >注意事項</span
                  >があります。<span class="bold red"
                    >良くお読みください。</span
                  >
                </p>
                <ul class="dotted bold mt20">
                  <li>
                    ワンコイン体験入塾は、<span class="border red"
                      >お手続きの当月末まで500円（税込）で、人気講義の一部をご受講頂ける</span
                    >制度です。
                  </li>
                  <li>
                    ワンコイン体験入塾は、翌月より入塾のご意志がある前提で入塾を解放するものです。このため、体験入塾期間を終えた翌月1日からは「本科」に自動入塾になる設定となっており、翌月からは月謝（16,500円・税込）が発生し、ご登録クレジットカードより自動決済されます。
                  </li>
                  <li>
                    もし翌月から「本科」に<span class="border red"
                      >入塾を希望しない場合</span
                    >は、<span class="border red"
                      >必ず期日までに「入塾キャンセル」の手続き</span
                    >を行ってください（キャンセル期日はお申込み確認メールに記載されます。必ずご確認願います）。期日までにキャンセル手続きを行わない場合は、入塾の意志があるものとして<span
                      class="border red"
                      >自動的に入塾手続き</span
                    >が取られます。<span class="border red"
                      >あらかじめご注意ください。</span
                    >
                  </li>
                  <li>
                    仮に上述の通り、入塾前に期日までにキャンセル手続きを頂いた場合は、月謝等の決済は一切行われません。
                  </li>
                </ul>
                <div class="alnC">
                  <img
                    src="/common/images/experience_cancel.png"
                    alt="キャンセルについて"
                  />
                </div>
              </div>
            </div>

            <div class="cts_box">
              <h3 class="min_ttl">利用規約をご一読ください</h3>
              <p class="lead_txt">
                利用規約をご一読いただき、これらの条件にご同意の上「利用規約に同意します」にチェックを入れてから「ゲストユーザー登録を開始する」ボタンを押してください。
              </p>
              <div class="mail_check">
                <form-error-box v-if="errors" />
                <div class="input_set">
                  <div class="label">複眼経済塾利用規約</div>
                  <div class="term_box">
                    <div class="scrl_box" v-html="term.text"></div>
                  </div>
                </div>
                <div class="input_set">
                  <div class="checkbox alnC">
                    <input
                      id="check01"
                      type="checkbox"
                      v-model="new_user.agreement"
                      value="1"
                      v-on:change="agreementChanged()"
                    />
                    <label for="check01" class="bold"
                      >複眼経済塾 利用規約に同意します</label
                    >
                  </div>
                </div>
              </div>
              <p class="alnC mt20 mb20">
                上記同意にチェックを入れるとゲストユーザー登録のボタンが表示されます。
              </p>
              <div class="button_wrap">
                <input
                  type="submit"
                  class="submit light"
                  value="ゲストユーザー登録を開始する"
                  v-bind:disabled="!this.new_user.agreement"
                />
              </div>

              <div class="cts_box alnC mt40" v-if="false">
                <p>
                  <router-link
                    :to="
                      campaign_code
                        ? {
                            name: 'UsersRegistrationPartner',
                            params: { campaign_code: campaign_code },
                          }
                        : {
                            name: 'UsersRegistration',
                          }
                    "
                    class="back"
                    >前のページにもどる
                  </router-link>
                </p>
              </div>
            </div>
          </form>
        </div>
        <!--//.wrap-->
      </section>
    </div>
    <!--//＃container-->
  </div>
</template>

<script>
import Libraries from "@/components/Libraries.vue";

export default {
  mixins: [Libraries],
  data() {
    if (!this.$store.state.user) {
      this.$store.state.user = {};
    }
    this.$store.state.user.shikiho = "";
    // this.$store.state.user.rank = 'rank_preparatory_month'
    this.$store.state.user.rank = "rank_free";
    return {
      new_user: this.$store.state.user,
      term: {},
      errors: null,
    };
  },
  mounted() {
    this.saveRedirectPath(this.$route.query.redirect)
    this.axios
      .get(`${this.env.api_base_url}term.json`)
      .then((response) => {
        this.term = response.data.term;
        this.new_user.term_id = this.term.id;
      })
      .catch((error) => {
        if (error.response.data && error.response.data.errors) {
          console.log(error.response.data);
        }
      });
  },
  created() {
    //
  },
  methods: {
    agreementChanged() {
      this.$forceUpdate();
    },

    submitClicked(event) {
      event.preventDefault();
      this.errors = null;
      if (!this.new_user.agreement) {
        this.errors = ["登録には利用規約に同意頂く必要があります。"];
      } else {
        // 遷移
        this.$router.push({ name: "UsersConfirmationFreePage1" });
      }
    },
  },
};
</script>
